import React from "react";
import Box from "@mui/material/Box";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import useStyled from "../../hooks/useStyled";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import { Colors } from "../../constants/colors";
const { styled } = useStyled();

//shouldForwardProp: (prop) => prop !== "open",
const LinearProgressStyled = styled(LinearProgress, {
  shouldForwardProp: (prop) =>
    prop != "narrow" &&
    prop != "maxWidth" &&
    prop != "completeColor" &&
    prop != "color",
})(({ theme, narrow = false, value, maxWidth, completeColor, color }) => ({
  width: "100%",
  ...(maxWidth && { maxWidth }),
  height: 10,
  ...(narrow && {
    height: 5,
  }),
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: color,
    ...(value === 100 && {
      backgroundColor: completeColor,
    }),
  },
}));

const SFProgress = ({
  title = null,
  titleVariant = "progressBarLabel",
  value = 0,
  narrow = false,
  maxWidth,
  completeColor = null,
  color = null,
}) => (
  <Box sx={{ width: "100%", maxWidth }}>
    <SFStack direction="column" spacing={0.5}>
      {title && <SFTypography variant={titleVariant}>{title}</SFTypography>}
      <LinearProgressStyled
        variant="determinate"
        value={value}
        narrow={narrow}
        {...completeColor && { completeColor }}
        {...color && { color }}
      />
    </SFStack>
  </Box>
);

export const SFProgressBar = ({
  value = 0,
  narrow = false,
  variant = "determinate",
  completeColor = Colors.GREEN300,
  color = Colors.BLUE300,
}) => (
  <LinearProgressStyled
    variant={variant}
    value={value}
    narrow={narrow}
    maxWidth
    completeColor={completeColor}
    color={color}
  />
);

export default SFProgress;
